<template>
  <div id="GangsheetReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Gangsheet Detail Report</div>
          <div class="web-action-btn btn-groups text-right">
              <!-- Button for Clear Cache
              <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'gangsheetReport'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="bg-white data-table">
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange" :moduleName="'gangsheetReport'" :position="'top'">
                </custom-pagination>
                <vue-good-table
                  mode="remote"
                  title="Gang Sheet Report"
                  ref="gangsheetReport"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  @on-select-all="onSelectAll"
                  @on-selected-rows-change="selectionChanged"
                  :totalRows="totalRecords"
                  :columns="userColumns"
                  :rows="rows"
                  :paginationOptions="{
                      enabled: false,
                      position: 'both',
                      perPage: perPage,
                      dropdownAllowAll: false,
                      setCurrentPage:listCurrentPage,
                      perPageDropdown:dropDownPerPage,
                  }"
                  :select-options="{
                      enabled: true,
                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                      selectionInfoClass: 'custom-class',
                      selectionText: 'rows selected',
                      clearSelectionText: 'clear',
                  }"
                  :search-options="{
                  enabled: false,
                  }"

                  >
                </vue-good-table>
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
  name: "GangsheetReport",
  metaInfo() {
            return {title: "Gangsheet Detail Report | " +process.env.COPYRIGHT_NAME}
        },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,
    action: '',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns: [
            {
                label: 'Indirect Labor Code',
                field: 'indirect_code',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Indirect Labor Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },

            },
            {
                label: 'Work Order Number',
                field: 'work_order_no',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Work Order Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },

            },
            {
                label: 'Job Description',
                field: 'job_desc',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Job Description", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },

            },
            {
                label: 'Payroll Hours',
                field: 'payroll_hrs',
                filterable: true,
                fpFieldType:"integer",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Payroll Hours", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },

            },
            {
                label: 'Establishment Code',
                field: 'establishment_code',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Establishment Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable : false,
            },
            {
                label: 'Job Classification Code',
                field: 'job_class_code',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Job Classification Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable : false,
            },
            {
                label: 'Payroll Approval Status Code',
                field: 'payroll_status_code',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Payroll Approval Status Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['1','2'],
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable : false,
            },
            {
                label: 'Payroll Approval Description',
                field: 'payroll_approval_description',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Payroll Approval Description", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable : false,
            },
            {
                label: 'Audit Record Status',
                field: 'audit_record_status',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Audit Record Status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable : false,
            },
            {
                label: 'Employee Last Name',
                field: 'employee_last_name',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Employee Last Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },

            },
            {
                label: 'Employee First Name',
                field: 'employee_first_name',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Employee First Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },

            },
            // {
            //     label: 'User',
            //     field: 'user',
            //     filterable: true,
            //     fpFieldType:"text",
            //     hidden:false,
            //     filterOptions: {
            //         enabled: false, // enable filter for this column
            //         placeholder: "User", // placeholder for filter input
            //         filterValue: '', // initial populated value for this filter
            //         trigger: "enter" //only trigger on enter not on keyup
            //     }
            // },
            // {
            //     label: 'Task Description',
            //     field: 'task_description',
            //     filterable: true,
            //     fpFieldType:"text",
            //     hidden:false,
            //     sortable: false,
            //     filterOptions: {
            //         enabled: false, // enable filter for this column
            //         placeholder: "Task Description", // placeholder for filter input
            //         filterValue: '', // initial populated value for this filter
            //         trigger: "enter" //only trigger on enter not on keyup
            //     },
            //     html: true
            // },
            {
                label: 'Facility ID Code',
                field: 'location',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Facility ID Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Facility Description',
                field: 'location_desc',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Facility Description", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Department Code',
                field: 'dept_code',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Department Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable : false,
            },
            {
                label: 'Department Description',
                field: 'dept_desc',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Department Description", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },

            },
            {
                label: 'Payroll Shift Code',
                field: 'payroll_shift_code',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Payroll Shift Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable : false,
            },
            {
                label: 'Payroll Department Description',
                field: 'payroll_dept_desc',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Payroll Department Description", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable : false,
            },
            {
                label: 'Employee Number',
                field: 'emp_number',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Employee Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },

            },
            {
                label: 'Processing Date',
                field: 'processing_date',
                filterable: true,
                fpFieldType:"custom_date",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Processing Date", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label: 'Sequence Number',
                field: 'seq_number',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Sequence Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable : false,
            },
            {
                label: 'Job Step Code',
                field: 'job_step_code',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Job Step Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable : false,
            },
            {
                label: 'Supervisor Approval ID',
                field: 'supervisor_approval_id',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Approval Approval ID", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable : false,
            },
            {
                label: 'Supervisor Approval Date',
                field: 'sup_approval_date',
                filterable: true,
                fpFieldType:"custom_date",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Supervisor Approval Date", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false//as data loaded conditionally from backend
            },
            {
                label: 'Supervisor Approval Time',
                field: 'sup_approval_time',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Approval Approval Time", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable : false,
            },
            {
                label: 'Payroll Approval ID',
                field: 'payroll_approval_id',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Payroll Approval ID", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable : false,
            },
            {
                label: 'Payroll Approval Date',
                field: 'payroll_approval_date',
                filterable: false,
                fpFieldType:"custom_date",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Payroll Approval Date", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable : false,
            },
            {
                label: 'Payroll Approval Time',
                field: 'payroll_approval_time',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Payroll Approval Time", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable : false,
            },
            {
                label: 'Batch Number',
                field: 'batch_number',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Batch Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable : false,
            },
            {
                label: 'Compensation Type Code',
                field: 'compensation_type_code',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Compensation Type Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable : false,
            },
            {
                label: 'Union Affiliation Code',
                field: 'union_affiliation_code',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Compensation Type Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable : false,
            },
            {
                label: 'Pay Year',
                field: 'pay_year',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Pay Year", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable : false,
            },
            {
                label: 'Pay Period',
                field: 'pay_period',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Pay Period", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable : false,
            },
            {
                label: 'Payroll Department Code',
                field: 'payroll_dept_code',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Payroll Department Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable : false,
            },
            // {
            //     label: 'Start Time',
            //     field: 'start_time',
            //     filterable: true,
            //     fpFieldType:"date",
            //     hidden:false,
            //     filterOptions: {
            //         enabled: false, // enable filter for this column
            //         placeholder: "Start Time", // placeholder for filter input
            //         filterValue: '', // initial populated value for this filter
            //         trigger: "enter" //only trigger on enter not on keyup
            //     }
            // },
            // {
            //     label: 'End Time',
            //     field: 'end_time',
            //     filterable: true,
            //     fpFieldType:"date",
            //     hidden:false,
            //     filterOptions: {
            //         enabled: false, // enable filter for this column
            //         placeholder: "End Time", // placeholder for filter input
            //         filterValue: '', // initial populated value for this filter
            //         trigger: "enter" //only trigger on enter not on keyup
            //     }
            // },
            // {
            //     label: 'Duration',
            //     field: 'duration',
            //     filterable: true,
            //     fpFieldType:"integer",
            //     hidden:false,
            //     filterOptions: {
            //         enabled: false, // enable filter for this column
            //         placeholder: "Duration", // placeholder for filter input
            //         filterValue: '', // initial populated value for this filter
            //         trigger: "enter" //only trigger on enter not on keyup
            //     }
            // },
            // {
            //     label: 'Updated Duration',
            //     field: 'updated_duration',
            //     filterable: true,
            //     fpFieldType:"integer",
            //     hidden:false,
            //     filterOptions: {
            //         enabled: false, // enable filter for this column
            //         placeholder: "Updated Duration", // placeholder for filter input
            //         filterValue: '', // initial populated value for this filter
            //         trigger: "enter" //only trigger on enter not on keyup
            //     }
            // },
        ],
    batchProcess:0,
    batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'gangsheet_detail_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{
    cancelAll: function (cancelAll) {
      this.$refs.gangsheetReport.unselectAllInternal();
    },
    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      var selectedRows = [];
      var data = this.$refs['gangsheetReport'].selectedRows;
      for ( var i = 0; i < data.length; i++ ) {
          selectedRows.push(this.$refs['gangsheetReport'].selectedRows[i].id)
      }
      var filterAll = self.serverParams.columnFilters;
      if ( self.action == "export" ) {
          filterAll = self.removeOptionArr(self.serverParams.columnFilters);
      }

      $.ajax({
        url: process.env.ROOT_API + "/gangsheet-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: filterAll,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action,
          selectedAll:self.serverParams.selectedAll,
          selectedRows:selectedRows,
        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          console.log(data.content.row);
          if (data.status == "success") {

            console.log('success');

            if ( self.action == "export" ||  self.action == "export_queue") {

                if ( data.code == "201" ) {
                    alert(data.message);
                } else {

                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);

                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }

                }

                self.action = "list";
                // self.loadList();
                return;
            } else {
              if (data.content.row != undefined) {
                console.log("data.content.log");
                self.rows = data.content.row;
              }
              self.totalRecords = data.content.totalRecords;
            }
          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'gangsheet-report');
        }
      });


    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/GangsheetReport.vue